module.exports = __webpack_public_path__ + "4c177e3d5002f37bf12f5bc742e63c74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/service/two/two-bg.jpg
// module id = 1219
// module chunks = 0